import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// All requests carry the httpOnly auth_token cookie automatically thanks to
// `withCredentials`. Tokens are no longer kept in localStorage (XSS-resistant).
export const api = axios.create({ baseURL: API, withCredentials: true });

// Short-lived ticket fetcher for WebSocket connections, which cannot send
// httpOnly cookies cleanly through the ingress.
export async function fetchWsTicket() {
  try {
    const r = await api.post("/auth/ws-ticket");
    return r.data.ticket;
  } catch {
    return null;
  }
}
